import { z } from 'zod';
export const projectsBillingRecipientSnapshotCapability = 'projects.billing-recipient-snapshot.v1';
export const projectsBillingRecipientSnapshotSchema = z.strictObject({
    contractVersion: z.literal(projectsBillingRecipientSnapshotCapability),
    projectId: z.string().uuid(),
    projectNumber: z.string().min(1).max(80),
    projectName: z.string().min(1).max(240),
    projectRevision: z.number().int().positive(),
    recipient: z.strictObject({
        name: z.string().max(240).nullable(),
        email: z.string().email().max(320).nullable(),
        addressLine1: z.string().max(240).nullable(),
        addressLine2: z.string().max(240).nullable(),
        city: z.string().max(120).nullable(),
        region: z.string().max(120).nullable(),
        postalCode: z.string().max(40).nullable(),
        countryCode: z.string().regex(/^[A-Z]{2}$/).nullable(),
    }),
});
//# sourceMappingURL=projects-billing-recipient-snapshot.contract.js.map